<div class="container-fluid manage-table">
  <div>
    <button type="button" class="btn btn-primary" style="float: right; margin-left: 10px;
    margin-bottom: 20px;" (click)="refreshData()"><i class="fa fa-refresh"></i> Refresh</button>
    <button type="button" class="btn btn-primary" style="float: right; margin-right: 10px; margin-bottom: 20px;"
      (click)="lockData()">
      <i [ngClass]="isLocked ? 'fa fa-unlock' : 'fa fa-lock'"></i>
      {{ isLocked ? 'Unlock' : 'Lock' }}
    </button>
    <div style="display: flex; justify-content: end;">
      <div *ngIf="isLocked" style="margin: 10px 10px 0px 0px; color: red; font-weight: bold;">
        This product business case is locked.
      </div>
      <div *ngIf="!isLocked" style="margin: 10px 10px 0px 0px; color: green; font-weight: bold;">
        This product business case is unlocked.
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <h3>RLD Price</h3>
    <div class="radio-group" *ngIf="selectedRLDPriceType !== undefined">
      <label>
        <input type="radio" name="rldPriceType" [value]="'per_unit_rld_price'" [(ngModel)]="selectedRLDPriceType"
          (ngModelChange)="onRLDPriceTypeChange($event)">
        Per Unit RLD Price
      </label>

      <label style="margin-left: 20px;">
        <input type="radio" name="rldPriceType" [value]="'pack_rld_price'" [(ngModel)]="selectedRLDPriceType"
          (ngModelChange)="onRLDPriceTypeChange($event)">
        Pack RLD Price
      </label>
    </div>

    <p *ngIf="rldPriceTableData.length == 0">No data available</p>
    <table class="table table-striped table-bordered text-cente" id="innertable" *ngIf="rldPriceTableData.length > 0">
      <thead style="font-size: 14px;">
        <th *ngFor="let headers of rldPriceTableData | tableHeaders">
          <p>{{headers}}</p>
          <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
        </th>
      </thead>
      <tbody style="font-size: 14px;">
        <tr *ngFor="let trows of rldPriceTableData | tableBody ;let m=index">
          <td *ngFor="let rdata of trows;let iindex =index">
            <p>{{rdata }}</p>
          </td>
        </tr>
      </tbody>
    </table>

    <h3>NDA</h3>
    <p *ngIf="dataNDA.length == 0">No data available</p>
    <table class="table table-striped table-bordered text-cente" id="innertable" *ngIf="dataNDA.length > 0">
      <thead style="font-size: 14px;">
        <th *ngFor="let headers of ndaTableHeaders;let i=index">
          <p>{{headers}}</p>
          <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
        </th>
      </thead>
      <tbody style="font-size: 14px;">
        <tr *ngFor="let trows of dataNDA | tableBody ;let m=index">
          <td *ngFor="let rdata of trows;let iindex =index">
            <p>{{rdata }}</p>
          </td>
        </tr>
      </tbody>
    </table>

    <h3>ANDA</h3>
    <p *ngIf="dataANDA.length == 0">No data available</p>
    <table class="table table-striped table-bordered text-cente" *ngIf="dataANDA.length > 0">
      <thead style="font-size: 14px;">
        <th *ngFor="let headers of andaTableHeaders ;let i=index">
          <p>{{headers}}</p>
          <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
        </th>
      </thead>
      <tbody style="font-size: 14px;">
        <tr *ngFor="let trows of dataANDA | tableBody ;let m=index">
          <td *ngFor="let rdata of trows;let iindex =index">
            <p>{{rdata }}</p>
          </td>
        </tr>
      </tbody>
    </table>




    <table class="table table-striped table-bordered text-center">
      <tbody>
        <tr>
          <td style="vertical-align: middle;">Future Volume Growth/Degrowth</td>
          <td>
            <div>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeAvailable">Fill Volume/Weight (ml or gm)</th>
                    <th>Default Values</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of strength; let i= index">
                    <td *ngIf="!show; else hide" style="width:10rem;">{{items.Strength}}</td>
                    <!-- <ng-template #hide>
                      <td><input type="text" [(ngModel)]="items.Strength"></td>
                    </ng-template> -->
                    <td *ngIf="isFillVolumeAvailable" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <!-- <td *ngIf="!showFutureFillVol; else hideFutureFillVol" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <!-- <ng-template #hideFutureFillVol>
                      <td><input type="text" [(ngModel)]="items['Fill Volume/Weight (ml or gm)']"></td>
                    </ng-template> -->
                    <td style="width:10rem;">
                      {{items.Default_Initial_value_damp}}</td>
                    <td *ngIf="!showIntialValue; else hideIntialValue" (click)="onClickEdit()" style="width:10rem;">
                      {{items.Initial_value_damp}}</td>
                    <ng-template #hideIntialValue>
                      <td><input type="text" [(ngModel)]="items.Initial_value_damp"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Growth</td>
          <td>
            <div>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeGrowth">Fill Volume/Weight (ml or gm)</th>
                    <th>Default Values</th>
                    <th>Growth</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of growth; let i= index">
                    <td *ngIf="!showGrowthStrength; else hideGrowthStrength" style="width:10rem;">{{items.Strength}}
                    </td>
                    <!-- <ng-template #hideGrowthStrength>
                      <td><input type="text" [(ngModel)]="items.Strength"></td>
                    </ng-template> -->
                    <!-- <td *ngIf="!showGrowthFillVol; else hideGrowthFillVol" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <td *ngIf="isFillVolumeGrowth" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <td style="width:10rem;">{{items.Default_Growth}}</td>
                    <td *ngIf="!showGrowth; else hideGrowth" (click)="onClickEdit()" style="width:10rem;">
                      {{items.Growth}}</td>
                    <ng-template #hideGrowth>
                      <td><input type="text" [(ngModel)]="items.Growth"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td style="vertical-align: middle;">Market Share (%)</td>
          <td *ngIf="!showMarketShare; else hideMarketShare" (click)="onClickEdit()">{{marketShare}}%</td>
          <ng-template #hideMarketShare>
            <td><input type="text" [(ngModel)]="marketShare"></td>
          </ng-template>
        </tr> -->
        <tr>
          <td style="vertical-align: middle;">Default Market Share (%)</td>
          <td>
            <div style="margin-left: 0%;">
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeDefaultMarketShare">Fill Volume/Weight (ml or gm)</th>
                    <th>Launch year</th>
                    <th>Year 1</th>
                    <th>Year 2</th>
                    <th>Year 3</th>
                    <th>Final year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of defaulMarketShare; let i = index">
                    <td style="width:10rem;">{{ item.Strength }}
                    </td>
                    <!-- <ng-template #hideMarketStrength>
                      <td><input type="text" [(ngModel)]="item.Strength"></td>
                    </ng-template> -->
                    <!-- <td *ngIf="!showMarketFillVol; else hideMarketFillVol" style="width:10rem;">
                      {{item['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <td *ngIf="isFillVolumeDefaultMarketShare" style="width:10rem;">

                      {{item['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <td style="width:10rem;">{{
                      item['Launch year'] }}%</td>
                    <td style="width:10rem;">{{
                      item['Year 1'] }}%</td>
                    <td style="width:10rem;">{{
                      item['Year 2'] }}%</td>
                    <td style="width:10rem;">{{
                      item['Year 3'] }}%</td>
                    <td style="width:10rem;">{{
                      item['Final year'] }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Market Share (%)</td>
          <td>
            <div style="margin-left: 0%;">
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeMarketShare">Fill Volume/Weight (ml or gm)</th>
                    <th>Launch year</th>
                    <th>Year 1</th>
                    <th>Year 2</th>
                    <th>Year 3</th>
                    <th>Final year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of marketShare; let i = index">
                    <td *ngIf="!showMarketStrength; else hideMarketStrength" style="width:10rem;">{{ item.Strength }}
                    </td>
                    <!-- <ng-template #hideMarketStrength>
                      <td><input type="text" [(ngModel)]="item.Strength"></td>
                    </ng-template> -->
                    <!-- <td *ngIf="!showMarketFillVol; else hideMarketFillVol" style="width:10rem;">
                      {{item['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <td *ngIf="isFillVolumeMarketShare" style="width:10rem;">

                      {{item['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <td *ngIf="!showMarketShare; else hideMarketShare" (click)="onClickEdit()" style="width:10rem;">{{
                      item['Launch year'] }}%</td>
                    <ng-template #hideMarketShare>
                      <td><input type="text" [(ngModel)]="item['Launch year']" style="width:6rem !important;"
                          [disabled]="isLocked"></td>
                    </ng-template>
                    <td *ngIf="!showMarketYear1; else hideMarketYear1" (click)="onClickEdit()" style="width:10rem;">{{
                      item['Year 1'] }}%</td>
                    <ng-template #hideMarketYear1>
                      <td><input type="text" [(ngModel)]="item['Year 1']" style="width:6rem !important;"
                          [disabled]="isLocked"></td>
                    </ng-template>
                    <td *ngIf="!showMarketYear2; else hideMarketYear2" (click)="onClickEdit()" style="width:10rem;">{{
                      item['Year 2'] }}%</td>
                    <ng-template #hideMarketYear2>
                      <td><input type="text" [(ngModel)]="item['Year 2']" style="width:6rem !important;"
                          [disabled]="isLocked"></td>
                    </ng-template>
                    <td *ngIf="!showMarketYear3; else hideMarketYear3" (click)="onClickEdit()" style="width:10rem;">{{
                      item['Year 3'] }}%</td>
                    <ng-template #hideMarketYear3>
                      <td><input type="text" [(ngModel)]="item['Year 3']" style="width:6rem !important;"
                          [disabled]="isLocked"></td>
                    </ng-template>
                    <td *ngIf="!showMarketfinal; else hideMarketfinal" (click)="onClickEdit()" style="width:10rem;">{{
                      item['Final year'] }}%</td>
                    <ng-template #hideMarketfinal>
                      <td><input type="text" [(ngModel)]="item['Final year']" style="width:6rem !important;"
                          [disabled]="isLocked"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;">RLD Price Increase (%)</td>
          <td>
            <div>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeRLD">Fill Volume/Weight (ml or gm)</th>
                    <th>Default Values</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of rld_price; let i= index">
                    <td *ngIf="!show; else hide" style="width:10rem;">{{items.strength}}</td>
                    <!-- <ng-template #hide>
                      <td><input type="text" [(ngModel)]="items.strength"></td>
                    </ng-template> -->
                    <!-- <td *ngIf="!showRLDFillVol; else hideRLDFillVol" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <td *ngIf="isFillVolumeRLD" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <td style="width:10rem;">{{items.Default_values}}</td>
                    <td *ngIf="!showIntialValue; else hideIntialValue" (click)="onClickEdit()" style="width:10rem;">
                      {{items.values}}</td>
                    <ng-template #hideIntialValue>
                      <td><input type="text" [(ngModel)]="items.values"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>

        <!-- <tr>
          <td style="vertical-align: middle;">Price Erosion (%)</td>
          <td>
            <div style="margin-left: 0%; display: flex; align-items: stretch;">
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of priceErosion_strength?.Strength | keyvalue; let i= index">
                    <td *ngIf="!showPriceErosionStrength; else hidePriceErosionStrength" style="width:8rem;">
                      {{items.value}}</td>
                  </tr>
                </tbody>
              </table>
              <table style="float: left">
                <thead>
                  <tr>
                    <th *ngIf="isFillVolumePriceEro">Fill Volume/Weight (ml or gm)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of priceErosion_fillVolume | keyvalue; let i= index">
                    <td *ngIf="!showErosionFillVol; else hideErosionFillVol" style="width: 10rem;">
                      {{items.value}}</td>
                    <ng-template #hidePriceErosionStrength>
                      <td *ngIf="isFillVolumePriceEro"><input type="text" [(ngModel)]="items.value" style="width:10rem;"
                          [value]="items.value" [id]="'priceErosion_fill_Vol_'+i" [name]="'priceErosion_fill_Vol_'+i">
                      </td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Launch year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of launch_year | keyvalue; let i= index">
                    <td *ngIf="!showLaunchYear; else hideLaunchYear" (click)="onClickEdit()" style="width:8rem;">
                      {{items.value}}</td>
                    <ng-template #hideLaunchYear>
                      <td><input type="text" [(ngModel)]="items.value" style="width:6rem !important;"
                          [value]="items.value" [id]="'launch_year_'+i" [name]="'launch_year_'+i"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Year 1</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of year_1 | keyvalue; let i= index">
                    <td *ngIf="!showYear1; else hideYear1" (click)="onClickEdit()" style="width:8rem;">{{items.value}}
                    </td>
                    <ng-template #hideYear1>
                      <td><input type="text" [(ngModel)]="items.value" style="width:6rem !important;"
                          [value]="items.value" [id]="'year_1_'+i" [name]="'year_1_'+i"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Year 2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of year_2 | keyvalue; let i= index">
                    <td *ngIf="!showYear2; else hideYear2" (click)="onClickEdit()" style="width:8rem;">{{items.value}}
                    </td>
                    <ng-template #hideYear2>
                      <td><input type="text" [(ngModel)]="items.value" style="width:6rem !important;"
                          [value]="items.value" [id]="'year_2_'+i" [name]="'year_2_'+i"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Year 3</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of year_3 | keyvalue; let i= index">
                    <td *ngIf="!showYear3; else hideYear3" (click)="onClickEdit()" style="width:8rem;">{{items.value}}
                    </td>
                    <ng-template #hideYear3>
                      <td><input type="text" [(ngModel)]="items.value" style="width:6rem !important;"
                          [value]="items.value" [id]="'year_3_'+i" [name]="'year_3_'+i"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Final year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of final_year | keyvalue; let i= index">
                    <td *ngIf="!showFinalYear; else hideFinalYear" (click)="onClickEdit()" style="width:8rem;">
                      {{items.value}}</td>
                    <ng-template #hideFinalYear>
                      <td><input type="text" [(ngModel)]="items.value" style="width:6rem !important;"
                          [value]="items.value" [id]="'final_year_'+i" [name]="'final_year_'+i"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr> -->
        <tr>
          <td style="vertical-align: middle;">Default Price Erosion (%)</td>
          <td>
            <div style="margin-left: 0%;">
              <table>
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeDefaultPriceErosion">Fill Volume/Weight (ml or gm)</th>
                    <th>Launch year</th>
                    <th>Year 1</th>
                    <th>Year 2</th>
                    <th>Year 3</th>
                    <th>Final year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let strength of defaultPriceErosion?.Strength; let i = index">
                    <td>
                      <ng-container>
                        {{ strength }}
                      </ng-container>
                    </td>

                    <td *ngIf="isFillVolumeDefaultPriceErosion && defaultPriceErosion_fillVolume">
                      <ng-container>
                        {{ defaultPriceErosion_fillVolume[i] }}
                      </ng-container>
                    </td>

                    <td>
                      <ng-container>
                        <p>{{ defaultLaunch_year && defaultLaunch_year[i] ? defaultLaunch_year[i] : '-' }}</p>
                      </ng-container>
                    </td>

                    <td>
                      <ng-container>
                        <p>{{ defaultYear_1 && defaultYear_1[i] ? defaultYear_1[i] : '-' }}</p>
                      </ng-container>
                    </td>

                    <td>
                      <ng-container>
                        <p>{{ defaultYear_2 && defaultYear_2[i] ? defaultYear_2[i] : '-' }}</p>
                      </ng-container>
                    </td>

                    <td>
                      <ng-container>
                        <p>{{ defaultYear_3 && defaultYear_3[i] ? defaultYear_3[i] : '-' }}</p>
                      </ng-container>
                    </td>

                    <td>
                      <ng-container>
                        <p>{{ defaultFinal_year && defaultFinal_year[i] ? defaultFinal_year[i] : '-' }}</p>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: middle;">Price Erosion (%)</td>
          <td>
            <div style="margin-left: 0%;">
              <table>
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumePriceEro">Fill Volume/Weight (ml or gm)</th>
                    <th>Launch year</th>
                    <th>Year 1</th>
                    <th>Year 2</th>
                    <th>Year 3</th>
                    <th>Final year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of priceErosion_strength?.Strength | keyvalue; let i = index">
                    <td>
                      <ng-container *ngIf="!showPriceErosionStrength; else editStrength">
                        {{ item.value }}
                      </ng-container>
                      <ng-template #editStrength>
                        <input type="text" [(ngModel)]="priceErosion_strength.Strength[item.key]" style="width:10rem;"
                          [disabled]="isLocked" />
                      </ng-template>
                    </td>

                    <td *ngIf="isFillVolumePriceEro">
                      <ng-container *ngIf="!showErosionFillVol; else editFillVol">
                        {{ priceErosion_fillVolume[i] }}
                      </ng-container>
                      <ng-template #editFillVol>
                        <input type="text" [(ngModel)]="priceErosion_fillVolume[i]" style="width:10rem;"
                          [value]="priceErosion_fillVolume[i]" [id]="'priceErosion_fill_Vol_'+i"
                          [name]="'priceErosion_fill_Vol_'+i" [disabled]="isLocked">
                      </ng-template>
                    </td>

                    <td>
                      <ng-container *ngIf="!showLaunchYear; else editLaunchYear">
                        <p (click)="onClickEdit()">{{ launch_year[i] }}</p>
                      </ng-container>
                      <ng-template #editLaunchYear>
                        <input type="text" [(ngModel)]="launch_year[i]" style="width:6rem !important;"
                          [value]="launch_year[i]" [id]="'launch_year_'+i" [name]="'launch_year_'+i"
                          [disabled]="isLocked">
                      </ng-template>
                    </td>

                    <td>
                      <ng-container *ngIf="!showYear1; else editYear1">
                        <p (click)="onClickEdit()">{{ year_1[i] }}</p>
                      </ng-container>
                      <ng-template #editYear1>
                        <input type="text" [(ngModel)]="year_1[i]" style="width:6rem !important;" [value]="year_1[i]"
                          [id]="'year_1_'+i" [name]="'year_1_'+i" [disabled]="isLocked">
                      </ng-template>
                    </td>

                    <td>
                      <ng-container *ngIf="!showYear2; else editYear2">
                        <p (click)="onClickEdit()">{{ year_2[i] }}</p>
                      </ng-container>
                      <ng-template #editYear2>
                        <input type="text" [(ngModel)]="year_2[i]" style="width:6rem !important;" [value]="year_2[i]"
                          [id]="'year_2_'+i" [name]="'year_2_'+i" [disabled]="isLocked">
                      </ng-template>
                    </td>

                    <td>
                      <ng-container *ngIf="!showYear3; else editYear3">
                        <p (click)="onClickEdit()">{{ year_3[i] }}</p>
                      </ng-container>
                      <ng-template #editYear3>
                        <input type="text" [(ngModel)]="year_3[i]" style="width:6rem !important;" [value]="year_3[i]"
                          [id]="'year_3_'+i" [name]="'year_3_'+i" [disabled]="isLocked">
                      </ng-template>
                    </td>

                    <td>
                      <ng-container *ngIf="!showFinalYear; else editFinalYear">
                        <p (click)="onClickEdit()">{{ final_year[i] }}</p>
                      </ng-container>
                      <ng-template #editFinalYear>
                        <input type="text" [(ngModel)]="final_year[i]" style="width:6rem !important;"
                          [value]="final_year[i]" [id]="'final_year_'+i" [name]="'final_year_'+i" [disabled]="isLocked">
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>






        <!-- <tr>
          <td style="vertical-align: middle;">Launch Year (Market formation Date)</td>
          <td *ngIf="!showMarketLaunchYear; else hideMarketLaunchYear" (click)="onClickEdit()">{{launch_year_market}}
          </td>
          <ng-template #hideMarketLaunchYear>
            <td><input type="text" [(ngModel)]="launch_year_market"></td>
          </ng-template>
        </tr> -->
        <tr>
          <td style="vertical-align: middle;">Launch Year (Market formation Date)</td>
          <td>
            <div>
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeLaunchYear">Fill Volume/Weight (ml or gm)</th>
                    <th>Launch Year</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let items of launch_year_market; let i= index">
                    <td *ngIf="!showMarketStrengthlaunch; else hideMarketStrengthlaunch" style="width:10rem;">{{
                      items.Strength }}</td>
                    <!-- <ng-template #hideMarketStrengthlaunch>
                      <td><input type="text" [(ngModel)]="items.Strength"></td>
                    </ng-template> -->
                    <!-- <td *ngIf="!showLaunchFillVol; else hideLaunchFillVol" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <td *ngIf="isFillVolumeLaunchYear" style="width:10rem;">
                      {{items['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <td *ngIf="!showMarketLaunchYear; else hideMarketLaunchYear" (click)="onClickEdit(item)">
                      {{ items.launch_year }}
                    </td>
                    <ng-template #hideMarketLaunchYear>
                      <td><input type="text" [(ngModel)]="items.launch_year"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;">COGs - (API + RMPM + Overheads + Packaging)</td>
          <td>
            <div style="margin-left: 0%;">
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strength</th>
                    <th *ngIf="isFillVolumeCogs">Fill Volume/Weight (ml or gm)</th>
                    <th>API(Database)</th>
                    <th>Overhead(Box6)</th>
                    <th>Packaging Cost</th>
                    <th>RMPM(Box5)</th>
                    <th>Final Cog</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let cogs of Cogs; let i= index">
                    <td *ngIf="!showCogsStrength; else hideCogsStrength" style="width:10rem;">
                      {{cogs.Strength}}</td>
                    <!-- <ng-template #hideCogsStrength>
                      <td><input type="text" [(ngModel)]="cogs.Strength"></td>
                    </ng-template> -->
                    <!-- <td *ngIf="!showCogsFillVol; else hideCogsFillVol" style="width:10rem;">
                      {{cogs['Fill Volume/Weight (ml or gm)']}}</td> -->
                    <td *ngIf="isFillVolumeCogs" style="width:10rem;">
                      {{cogs['Fill Volume/Weight (ml or gm)']}}
                    </td>
                    <td *ngIf="!showApiDatabase; else hideApiDatabase" style="width:10rem;">
                      {{cogs['API(Database)']}}</td>
                    <td *ngIf="!showOverhead; else hideOverhead" (click)="onClickEdit()" style="width:10rem;">
                      {{cogs['Overhead(Box6)']}}</td>
                    <ng-template #hideOverhead>
                      <td><input type="text" [(ngModel)]="cogs['Overhead(Box6)']"></td>
                    </ng-template>
                    <td *ngIf="!showPackagingCost; else hidePackagingCost" style="width:10rem;">
                      {{cogs['Packaging Cost']}}</td>
                    <td *ngIf="!showRMPMBox5; else hideRMPMBox5" (click)="onClickEdit()" style="width:10rem;">
                      {{cogs['RMPM(Box5)']}}</td>
                    <ng-template #hideRMPMBox5>
                      <td><input type="text" [(ngModel)]="cogs['RMPM(Box5)']"></td>
                    </ng-template>
                    <td *ngIf="!showFinalCogs; else hideFinalCogs" (click)="onClickEdit()" style="width:10rem;">
                      {{cogs.Final_COG}}</td>
                    <ng-template #hideFinalCogs>
                      <td><input type="text" [(ngModel)]="cogs.Final_COG"></td>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Therapeutic Category</td>
          <td *ngIf="!showTheraputicClass; else hideTheraputicClass" (click)="onClickEdit()">{{therapeuticClass}}</td>
          <ng-template #hideTheraputicClass>
            <td><input type="text" [(ngModel)]="therapeuticClass"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">API Price (USD/KG)</td>
          <td *ngIf="!showApiPrice; else hideApiPrice" (click)="onClickEdit()">{{apiPrice}}</td>
          <ng-template #hideApiPrice>
            <td><input type="text" [(ngModel)]="apiPrice"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Peak Year</td>
          <td *ngIf="!showpeakYear; else hidepeakYear" (click)="onClickEdit()">{{peakYear}}</td>
          <ng-template #hidepeakYear>
            <td><input type="text" [(ngModel)]="peakYear"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Capex</td>
          <td *ngIf="!showCapex; else hideCapex" (click)="onClickEdit()">{{capex}}</td>
          <ng-template #hideCapex>
            <td><input type="text" [(ngModel)]="capex"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Peak Sales Input</td>
          <td *ngIf="!showPeakSalesInput; else hidePeakSalesInput" (click)="onClickEdit()">{{peakSalesInput | number:
            '2.'}}</td>
          <ng-template #hidePeakSalesInput>
            <td><input type="text" [(ngModel)]="peakSalesInput"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Peak Sales Output (10% Difference)</td>
          <td *ngIf="!showPeakSalesOutput; else hidePeakSalesOutput" (click)="onClickEdit()">{{peakSalesOutput | number:
            '2.0-0'}}</td>
          <ng-template #hidePeakSalesOutput>
            <td><input type="text" [(ngModel)]="peakSalesOutput"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Logistics</td>
          <td *ngIf="!showLogistics; else hideLogistics" (click)="onClickEdit()">{{logistics}}</td>
          <ng-template #hideLogistics>
            <td><input type="text" [(ngModel)]="logistics"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">SG&A</td>
          <td *ngIf="!showSga; else hideSga" (click)="onClickEdit()">{{sga}}</td>
          <ng-template #hideSga>
            <td><input type="text" [(ngModel)]="sga"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Insurance & Rebates</td>
          <td *ngIf="!showInsurance; else hideInsurance" (click)="onClickEdit()">{{Insurance}}</td>
          <ng-template #hideInsurance>
            <td><input type="text" [(ngModel)]="Insurance"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">WACC</td>
          <td *ngIf="!showWacc; else hideWacc" (click)="onClickEdit()">{{wacc}}</td>
          <ng-template #hideWacc>
            <td><input type="text" [(ngModel)]="wacc"></td>
          </ng-template>
        </tr>
        <tr>
          <td style="vertical-align: middle;">Tax</td>
          <td *ngIf="!showTax; else hideTax" (click)="onClickEdit()">{{tax}}</td>
          <ng-template #hideTax>
            <td><input type="text" [(ngModel)]="tax"></td>
          </ng-template>
        </tr>
        <!-- <tr>
          <td style="vertical-align: middle;">No.of Expected Entrants</td>
          <td *ngIf="!showExpectedEntrance; else hideExpectedEntrance" (click)="onClickEdit()">{{expected_entrants}}
          </td>
          <ng-template #hideExpectedEntrance>
            <td><input type="text" [(ngModel)]="expected_entrants"></td>
          </ng-template>
        </tr> -->
        <tr>
          <td style="vertical-align: middle;">No. of Expected Entrants</td>
          <td>
            <div style="margin-left: 0%;">
              <table style="float: left">
                <thead>
                  <tr>
                    <th>Strengths</th>
                    <th>Total Approved ANDA filers</th>
                    <th>Total Tentatively approved ANDAs</th>
                    <th>Total Filed ANDA</th>
                    <th>Total Expected ANDA Entrants</th>
                    <th>All Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let entrant of expected_entrants; let i = index">
                    <td *ngIf="!showExpectedEntrance; else hideExpectedEntrance">{{
                      entrant.Strengths }}</td>
                    <td *ngIf="!showExpectedANDA; else hideExpectedANDA">{{
                      entrant['Approved ANDA filers'] }}</td>
                    <td *ngIf="!showExpectedTentative; else hideExpectedTentative">{{
                      entrant['Tentatively approved ANDAs'] }}</td>
                    <td *ngIf="!showExpectedFiled; else hideExpectedFiled">{{
                      entrant['Filed ANDA'] }}</td>
                    <td *ngIf="!showExpectedEntrants; else hideExpectedEntrants">{{
                      entrant['Expected ANDA Entrants'] }}</td>
                    <td *ngIf="!showExpectedAll; else hideExpectedAll">{{ entrant['All Total']
                      }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-primary" style="float: right;
    margin-right: 20px; margin-top: 20px;" (click)="editedBusinessCaseData()">Save</button>
  </div>

  <div class="row mx-0 m-3 float-right">

  </div>
  <div class="table-responsive" style="width: 500px">
    <table class="table table-striped table-bordered text-center">
      <tr>
        <td style="background-color: #F3F8FD;">NPV</td>
        <td style="color: #17A11C; font-weight: 600;" contenteditable="true">{{npvData?.NPV | number:'1.0-0'}}</td>
      </tr>
      <tr>
        <td style="background-color: #F3F8FD;">IRR</td>
        <td style="color: #175DA1; font-weight: 600;" contenteditable="true">{{npvData?.IRR}}</td>
      </tr>
      <tr>
        <td style="background-color: #F3F8FD;">BE</td>
        <td style="color: #17A11C; font-weight: 600;" contenteditable="true">{{npvData?.BE_YEAR}}</td>
      </tr>
    </table>
  </div>

  <div class="p-table" *ngIf="businessCase" style="width:81rem;">
    <p-table [value]="businessCase.data" scrollDirection="both" [scrollable]="true">
      <ng-template pTemplate="header">
        <tr>
          <th pFrozenColumn style="width:100px; left: 0; position: sticky;z-index: 9999;"></th>
          <th *ngFor="let col of columns.header" style="width:100px;">
            {{ col }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <td *ngIf="rowIndex === 0" pFrozenColumn
          style="background-color: #E7EAEF;font-weight:500;text-align: -webkit-center; width: 100px; left: 0; position: sticky;z-index: 9999;">
          <tr>Revenue</tr>
          <hr />
          <tr>COGS</tr>
          <hr />
          <tr>Margin</tr>
          <hr />
          <tr>GM%</tr>
          <hr />
          <tr>OPEX</tr>
          <hr />
          <tr>EBITDA</tr>
          <hr />
          <tr>D&A</tr>
          <hr />
          <tr>PBT</tr>
          <hr />
          <tr>Net Tax</tr>
          <hr />
          <tr>PAT</tr>
        </td>
        <td style="text-align: -webkit-center; width:100px;">
          <tr>{{rowData.Revenue}}</tr>
          <hr />
          <tr>{{rowData.COGs}}</tr>
          <hr />
          <tr>{{rowData.Margin}}</tr>
          <hr />
          <tr>{{rowData.GM}}</tr>
          <hr />
          <tr>{{rowData.OPEX}}</tr>
          <hr />
          <tr>{{rowData.EBITDA}}</tr>
          <hr />
          <tr>{{rowData.DandA}}</tr>
          <hr />
          <tr>{{rowData.PBT}}</tr>
          <hr />
          <tr>{{rowData.NetTax}}</tr>
          <hr />
          <tr>{{rowData.PAT}}</tr>
        </td>
      </ng-template>
    </p-table>
  </div>
  <div class="p-table " *ngIf="zeroBusinessData">
    <p-table scrollDirection="both" [scrollable]="true" [value]="zeroBusinessData.data">
      <ng-template pTemplate="header">
        <tr>
          <th pFrozenColumn style="width:100px; left: 0; position: sticky;z-index: 9999;"></th>
          <th *ngFor="let col of columns?.header">
            {{ col }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <td *ngIf="rowIndex === 0"
          style="background-color: #E7EAEF;font-weight:500;text-align: -webkit-center; width: 100px; left: 0; position: sticky;z-index: 9999;">
          <tr pFrozenColumn>Revenue</tr>
          <hr />
          <tr>COGS</tr>
          <hr />
          <tr>Margin</tr>
          <hr />
          <tr>GM%</tr>
          <hr />
          <tr>OPEX</tr>
          <hr />
          <tr>EBITDA</tr>
          <hr />
          <tr>D&A</tr>
          <hr />
          <tr>PBT</tr>
          <hr />
          <tr>Net Tax</tr>
          <hr />
          <tr>PAT</tr>
        </td>
        <td style="text-align: -webkit-center;">
          <tr>{{rowData.Revenue}}</tr>
          <hr />
          <tr>{{rowData.COGs}}</tr>
          <hr />
          <tr>{{rowData.Margin}}</tr>
          <hr />
          <tr>{{rowData.GM}}</tr>
          <hr />
          <tr>{{rowData.OPEX}}</tr>
          <hr />
          <tr>{{rowData.EBITDA}}</tr>
          <hr />
          <tr>{{rowData.DandA}}</tr>
          <hr />
          <tr>{{rowData.PBT}}</tr>
          <hr />
          <tr>{{rowData.NetTax}}</tr>
          <hr />
          <tr>{{rowData.PAT}}</tr>
        </td>
      </ng-template>
    </p-table>
  </div>
</div>